import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from '../modules';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['song/INIT_PLAYER'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.player'],
        // Ignore these paths in the state
        ignoredPaths: ['song.player'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
